import * as React from 'react';
import { RouteObject } from 'react-router-dom';

// Survey Containers
const AdminSurveys = React.lazy(
    () => import(/* webpackChunkName: "admin-surveys" */ '../../../../containers/Admin/Surveys')
);
const SurveyModules = React.lazy(
    () => import(/* webpackChunkName: "admin-survey-modules" */ '../../../../containers/Admin/Surveys/children/Modules')
);
const SurveyResponses = React.lazy(
    () =>
        import(
            /* webpackChunkName: "admin-survey-responses" */ '../../../../containers/Admin/Surveys/children/Responses'
        )
);
const AdminResponse = React.lazy(
    () =>
        import(/* webpackChunkName: "admin-survey-response" */ '../../../../containers/Admin/Surveys/children/Response')
);

export const AdminSurveysRoutes: RouteObject = {
    path: 'surveys',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminSurveys />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <SurveyResponses />
                </React.Suspense>
            )
        },
        {
            path: 'modules',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <SurveyModules />
                </React.Suspense>
            )
        },
        {
            path: 'survey/:surveyId',
            element: (
                <React.Suspense fallback={<>...</>}>
                    <AdminResponse />
                </React.Suspense>
            )
        }
    ]
};
